import { render, staticRenderFns } from "./content_edit.vue?vue&type=template&id=49fed3a4&scoped=true"
import script from "./content_edit.vue?vue&type=script&lang=js"
export * from "./content_edit.vue?vue&type=script&lang=js"
import style0 from "./content_edit.vue?vue&type=style&index=0&id=49fed3a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fed3a4",
  null
  
)

export default component.exports